import React, {useState, useEffect} from "react";
import {Accordion, AccordionDetails, AccordionSummary, Box, Divider, Grid} from "@mui/material";
import VolumeComponent from "./VolumeComponent";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import {useGroup} from "../contexts/GroupContext";
import {makeStyles, withStyles} from "@mui/styles";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import SendIcon from "@mui/icons-material/Send";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MenuItem from "@mui/material/MenuItem";
//import { storage } from "../firebase";

function SettingsComponent() {

    //State
    const { sendUserInput, botNames, botSerials, selectedBot, setSelectedBot, setSelectedSerial, isV2, locationDocs, dolphinEnabled} = useGroup() //group
    const [settingsOpen, setSettingsOpen] = useState(false)
    const [audioSettingsOpen, setAudioSettingsOpen] = useState(false)
    const [kioskSettingsOpen, setKioskSettingsOpen] = useState(false)
    const [behaviorSettingsOpen, setBehaviorSettingsOpen] = useState(false)
    const [batterySettingsOpen, setBatterySettingsOpen] = useState(false)
    const [utilitiesSettingsOpen, setUtilitiesSettingsOpen] = useState(false)
    const [ready, setReady] = useState(false)
    const [locationNames, setLocationNames] = useState([]);
    const [kioskLocation, setKioskLocation] = useState("");

    const useStyles = makeStyles((theme) => ({
        subMenuItem: {
            backgroundColor: theme.palette.custom.backgroundTwo,
            padding: theme.spacing(2),
            paddingTop: theme.spacing(1.5),
            paddingBottom: theme.spacing(1.5)
        },
    }));

    const classes = useStyles();

    const HeaderTypography = withStyles((theme) => ({
        root: {
            paddingLeft: theme.spacing(2),
            fontWeight: 'bold',
            textAlign: 'start',
            fontSize: 'large'
        },
    }))(Typography);

    const SubMenuAccordionSummary = withStyles((theme) => ({
        root: {
            paddingLeft: theme.spacing(3),
        },
    }))(AccordionSummary);

    function handleSettingsOpen(open) {
        setSettingsOpen(!open)
    }

    function handleAudioSettingsOpen(open) {
        setAudioSettingsOpen(!open)
    }

    function handleKioskSettingsOpen(open) {
        setKioskSettingsOpen(!open)
    }

    function handleBehaviorSettingsOpen(open) {
        setBehaviorSettingsOpen(!open)
    }

    function handleBatterySettingsOpen(open) {
        setBatterySettingsOpen(!open)
    }

    function handleUtilitiesSettingsOpen(open) {
        setUtilitiesSettingsOpen(!open)
    }

    //TODO: Will: Move these to their own components which have their own listeners to the settings
    const handleEscortAttemptsSubmit = (event) => {
        const setting = document.getElementById('escortAttemptsField').value;
        if (setting >= 1) {
            sendUserInput("setescortattemptsto " + setting);
        } else {
            alert("Please input a valid escort attempt number! (Greater than or equal to 1)");
        }
    };

    const generateEscortAttemptsSetting = () => {
        return (
            <>
                <Grid container item xs>
                    <Grid item xs={4}>
                        <HeaderTypography>Escort Attempts: </HeaderTypography>
                    </Grid>
                    <Grid item xs>
                        <TextField variant={'standard'} 
                                   autoComplete='off'
                                   helperText="Number of times that Zeeno will ask for the patient to come with it (Min. 1)"
                                   id="escortAttemptsField"
                                   label="Number of Escort Attempts..."
                                   type="number"
                                   fullWidth/>
                    </Grid>
                </Grid>
                <Grid item xs={1}>
                    <IconButton color="primary" onClick={handleEscortAttemptsSubmit}>
                         <SendIcon color='send'/>
                    </IconButton>
                </Grid>
            </>
        )
    };

    const handleEscortDurationSubmit = (event) => {
        if (isV2) {
            const setting = document.getElementById('escortDurationField').value;
            if (setting >= 5) {
                sendUserInput("setescortdurationto " + setting);
            } else {
                alert("Please input a valid escort wait duration number! (Greater than or equal to 5 seconds)");
            }
        } else {
            const setting = document.getElementById('escortDurationField').value;
            if (setting >= 10) {
                sendUserInput("setescortdurationto " + setting);
            } else {
                alert("Please input a valid escort wait duration number! (Greater than or equal to 10 seconds)");
            }
        }
    };

    const generateEscortDurationSetting = () => {
        if (isV2) {
                return (
                    <>
                        <Grid container item xs>
                            <Grid item xs={4}>
                                <HeaderTypography>Escort Duration: </HeaderTypography>
                            </Grid>
                            <Grid item xs>
                                <TextField variant={'standard'} 
                                           autoComplete='off'
                                           helperText="Duration of time Zeeno will wait for the patient to respond in seconds (Min. 5)"
                                           id="escortDurationField"
                                           label="Duration of Escort Wait..."
                                           type="number"
                                           fullWidth/>
                            </Grid>
                        </Grid>
                        <Grid item xs={1}>
                            <IconButton color="primary" onClick={handleEscortDurationSubmit}>
                                 <SendIcon color='send'/>
                            </IconButton>
                        </Grid>
                    </>
                )
        }
         else {
            return (
                <>
                    <Grid container item xs>
                        <Grid item xs={4}>
                            <HeaderTypography>Escort Duration: </HeaderTypography>
                        </Grid>
                        <Grid item xs>
                            <TextField variant={'standard'} 
                                       autoComplete='off'
                                       helperText="Duration of time Zeeno will wait for the patient to respond in seconds (Min. 10)"
                                       id="escortDurationField"
                                       label="Duration of Escort Wait..."
                                       type="number"
                                       fullWidth/>
                        </Grid>
                    </Grid>
                    <Grid item xs={1}>
                        <IconButton color="primary" onClick={handleEscortDurationSubmit}>
                             <SendIcon color='send'/>
                        </IconButton>
                    </Grid>
                </>
            )
        }
    };

    const handleLowBatteryWarningSubmit = (event) => {
        const setting = document.getElementById('lowBatteryWarningField').value;
        if (setting >= 20 && setting <= 100) {
            sendUserInput("setbatterywarnlevelto " + setting);
        } else {
            alert("Please input a valid battery level! (Between 20% and 100%)");
        }
    };

    const generateLowBatteryWarningSetting = () => {
        return (
            <>
                <Grid container item xs>
                    <Grid item xs={4}>
                        <HeaderTypography>Low Battery Warning: </HeaderTypography>
                    </Grid>
                    <Grid item xs>
                        <TextField variant={'standard'} 
                                   autoComplete='off'
                                   helperText="Percentage of battery at which the user will be warned of low battery."
                                   id="lowBatteryWarningField"
                                   label="Low Battery Warning Level..."
                                   type="number"
                                   fullWidth/>
                    </Grid>
                </Grid>
                <Grid item xs={1}>
                    <IconButton color="primary" onClick={handleLowBatteryWarningSubmit}>
                         <SendIcon color='send'/>
                    </IconButton>
                </Grid>
            </>
        )
    };

    const handleRechargeSubmit = (event) => {
        const setting = document.getElementById('rechargeField').value;
        if (setting >= 15 && setting <= 95) {
            sendUserInput("setbatteryabortlevelto " + setting);
        } else {
            alert("Please input a valid battery level! (Between 15% and 95%)");
        }
    };

    const generateRechargeSetting = () => {
        return (
            <>
                <Grid container item xs>
                    <Grid item xs={4}>
                        <HeaderTypography>Recharge Battery Level: </HeaderTypography>
                    </Grid>
                    <Grid item xs>
                        <TextField variant={'standard'} 
                                   autoComplete='off'
                                   helperText="Percentage of battery at which Zeeno will automatically stop tasks and go to recharge."
                                   id="rechargeField"
                                   label="Recharge Level..."
                                   type="number"
                                   fullWidth/>
                    </Grid>
                </Grid>
                <Grid item xs={1}>
                    <IconButton color="primary" onClick={handleRechargeSubmit}>
                         <SendIcon color='send'/>
                    </IconButton>
                </Grid>
            </>
        )
    };

    const handleEndChargeSubmit = (event) => {
        const setting = document.getElementById('endChargeField').value;
        if (setting >= 50 && setting <= 100) {
            sendUserInput("setbatterychargedlevelto " + setting);
        } else {
            alert("Please input a valid battery level! (Between 50% and 100%)");
        }
    };

    const generateEndChargeSetting = () => {
        return (
            <>
                <Grid container item xs>
                    <Grid item xs={4}>
                        <HeaderTypography>End Charge Battery Level: </HeaderTypography>
                    </Grid>
                    <Grid item xs>
                        <TextField variant={'standard'} 
                                   autoComplete='off'
                                   helperText="Percentage of battery at which Zeeno will stop recharging itself and be available for tasks."
                                   id="endChargeField"
                                   label="End Charge Level..."
                                   type="number"
                                   fullWidth/>
                    </Grid>
                </Grid>
                <Grid item xs={1}>
                    <IconButton color="primary" onClick={handleEndChargeSubmit}>
                         <SendIcon color='send'/>
                    </IconButton>
                </Grid>
            </>
        )
    };

    const handleSendMapSubmit = (event) => {
        if (sendUserInput("sendMap")) {
            alert("Wait a few moments then press the refresh button on the map above to display the updated area")
        }
    };

    const generateSendMapSetting = () => {
        return (
            <>
                <Grid container item xs>
                    <Grid item xs={4}>
                        <HeaderTypography>Send Map to Server</HeaderTypography>
                    </Grid>
                </Grid>
                <Grid item xs={1}>
                    <IconButton color="primary" onClick={handleSendMapSubmit}>
                         <SendIcon color='send'/>
                    </IconButton>
                </Grid>
            </>
        )
    };

    const handleSendLogsSubmit = (event) => {
        sendUserInput("sendLogs");
    };

    const generateSendLogsSetting = () => {
        return (
            <>
                <Grid container item xs>
                    <Grid item xs={4}>
                        <HeaderTypography>Send Logs to Server</HeaderTypography>
                    </Grid>
                </Grid>
                <Grid item xs={1}>
                    <IconButton color="primary" onClick={handleSendLogsSubmit}>
                         <SendIcon color='send'/>
                    </IconButton>
                </Grid>
            </>
        )
    };

    const handleRequestPermissionsSubmit = (event) => {
        sendUserInput("requestpermissions");
    };

    const generateRequestPermissionsSetting = () => {
        return (
            <>
                <Grid container item xs>
                    <Grid item xs={4}>
                        <HeaderTypography>Re-request Android Permissions</HeaderTypography>
                    </Grid>
                </Grid>
                <Grid item xs={1}>
                    <IconButton color="primary" onClick={handleRequestPermissionsSubmit}>
                         <SendIcon color='send'/>
                    </IconButton>
                </Grid>
            </>
        )
    };

//    const handleRestartAppSubmit = (event) => {
//        sendUserInput("restartapp");
//    };

//    const generateRestartAppSetting = () => {
//        return (
//            <>
//                <Grid container item xs>
//                    <Grid item xs>
//                        <Paper >Restart App on Robot</Paper>
//                    </Grid>
//                </Grid>
//                <Grid item xs={1}>
//                    <IconButton color="primary" onClick={handleRestartAppSubmit}>
//                         <SendIcon color='send'/>
//                    </IconButton>
//                </Grid>
//            </>
//        )
//    };

    const handleShowTopBarSubmit = (event) => {
        sendUserInput("showtopbar");
    };

    const generateShowTopBarSetting = () => {
        return (
            <>
                <Grid container item xs>
                    <Grid item xs={4}>
                        <HeaderTypography>Show Top Navigation Bar on Robot</HeaderTypography>
                    </Grid>
                </Grid>
                <Grid item xs={1}>
                    <IconButton color="primary" onClick={handleShowTopBarSubmit}>
                         <SendIcon color='send'/>
                    </IconButton>
                </Grid>
            </>
        )
    };

    const handlePrivacyModeSubmit = (event) => {
        const setting = document.getElementById('privacyModeField').innerText;
        if (setting === "on") {
            sendUserInput("enableprivacymode");
        } else if (setting === "off") {
            sendUserInput("disableprivacymode");
        } else {
            alert("Please select \"on\" or \"off\" before sending");
        }
    };

    const generatePrivacyModeSetting = () => {
        if (isV2) {
        return (
                    <>
                        <Grid container item xs>
                            <Grid item xs={4}>
                                <HeaderTypography>Privacy Mode:</HeaderTypography>
                            </Grid>
                            <Grid item xs>
                                <TextField autoFocus variant={'standard'} select id="privacyModeField" label="Toggle..." helperText="If on, Zeeno will no longer listen for voice commands." fullWidth defaultValue="">
                                        <MenuItem key={true} value={true}>
                                            {"on"}
                                        </MenuItem>
                                        <MenuItem key={false} value={false}>
                                            {"off"}
                                        </MenuItem>
                                </TextField>
                            </Grid>
                        </Grid>
                        <Grid item xs={1}>
                            <IconButton color="primary" onClick={handlePrivacyModeSubmit}>
                                 <SendIcon color='send'/>
                            </IconButton>
                        </Grid>
                    </>
                )
        }
        else {
            return (
                <>
                    <Grid container item xs>
                        <Grid item xs={4}>
                            <HeaderTypography>Voice Commands: </HeaderTypography>
                        </Grid>
                        <Grid item xs>
                            <TextField autoFocus variant={'standard'} select id="privacyModeField" label="Toggle..." helperText="Determines whether the voice command button on Zeeno is enabled" fullWidth defaultValue="">
                                    <MenuItem key={true} value={true}>
                                        {"on"}
                                    </MenuItem>
                                    <MenuItem key={false} value={false}>
                                        {"off"}
                                    </MenuItem>
                            </TextField>
                        </Grid>
                    </Grid>
                    <Grid item xs={1}>
                        <IconButton color="primary" onClick={handlePrivacyModeSubmit}>
                             <SendIcon color='send'/>
                        </IconButton>
                    </Grid>
                </>
            )
        }
    };

    const handleVoiceAckSubmit = (event) => {
        const setting = document.getElementById('voiceAckField').innerText;
        if (setting === "on") {
            sendUserInput("enablevoiceack");
        } else if (setting === "off") {
            sendUserInput("disablevoiceack");
        } else {
            alert("Please select \"on\" or \"off\" before sending");
        }
    };

    const generateVoiceAckSetting = () => {
        return (
            <>
                <Grid container item xs>
                    <Grid item xs={4}>
                        <HeaderTypography>Voice Acknowledgement: </HeaderTypography>
                    </Grid>
                    <Grid item xs>
                        <TextField autoFocus variant={'standard'} select id="voiceAckField" label="Toggle..." helperText="If on, Zeeno will automatically listen for voice commands after requesting patient acknowledgement." fullWidth defaultValue="">
                                <MenuItem key={true} value={true}>
                                    {"on"}
                                </MenuItem>
                                <MenuItem key={false} value={false}>
                                    {"off"}
                                </MenuItem>
                        </TextField>
                    </Grid>
                </Grid>
                <Grid item xs={1}>
                    <IconButton color="primary" onClick={handleVoiceAckSubmit}>
                         <SendIcon color='send'/>
                    </IconButton>
                </Grid>
            </>
        )
    };

    const handleHardwareButtonsSubmit = (event) => {
        const setting = document.getElementById('hardwareButtonsField').innerText;
        if (setting === "on") {
            sendUserInput("enablebuttons");
        } else if (setting === "off") {
            sendUserInput("disablebuttons");
        } else {
            alert("Please select \"on\" or \"off\" before sending");
        }
    };

    const generateHardwareButtonsSetting = () => {
        return (
            <>
                <Grid container item xs>
                    <Grid item xs={4}>
                        <HeaderTypography>Hardware Buttons: </HeaderTypography>
                    </Grid>
                    <Grid item xs>
                        <TextField autoFocus variant={'standard'} select id="hardwareButtonsField" label="Toggle..." helperText="If on, the volume and follow buttons on the Zeeno tablet will be usable." fullWidth defaultValue="">
                            <MenuItem key={true} value={true}>
                                {"on"}
                            </MenuItem>
                            <MenuItem key={false} value={false}>
                                {"off"}
                            </MenuItem>
                        </TextField>
                    </Grid>
                </Grid>
                <Grid item xs={1}>
                    <IconButton color="primary" onClick={handleHardwareButtonsSubmit}>
                         <SendIcon color='send'/>
                    </IconButton>
                </Grid>
            </>
        )
    };

    const handleObstacleNotificationSubmit = (event) => {
        const setting = document.getElementById('obstacleNotificationsField').innerText;
        if (setting === "on") {
            sendUserInput("enableobstaclenotifications");
        } else if (setting === "off") {
            sendUserInput("disableobstaclenotifications");
        } else {
            alert("Please select \"on\" or \"off\" before sending");
        }
    };

    const generateObstacleNotificationSetting = () => {
        return (
            <>
                <Grid container item xs>
                    <Grid item xs={4}>
                        <HeaderTypography>Obstacle Notifications: </HeaderTypography>
                    </Grid>
                    <Grid item xs>
                        <TextField autoFocus variant={'standard'} select id="obstacleNotificationsField" label="Toggle..." helperText="If on, Zeeno will beep when encountering obstacles while navigating." fullWidth defaultValue="">
                            <MenuItem key={true} value={true}>
                                {"on"}
                            </MenuItem>
                            <MenuItem key={false} value={false}>
                                {"off"}
                            </MenuItem>
                        </TextField>
                    </Grid>
                </Grid>
                <Grid item xs={1}>
                    <IconButton color="primary" onClick={handleObstacleNotificationSubmit}>
                         <SendIcon color='send'/>
                    </IconButton>
                </Grid>
            </>
        )
    };

    //TODO: do this in groupContext and pass to components, don't do this here
    var Small = {
        'zero': 0,
        'one': 1,
        'two': 2,
        'three': 3,
        'four': 4,
        'five': 5,
        'six': 6,
        'seven': 7,
        'eight': 8,
        'nine': 9,
        'ten': 10,
        'eleven': 11,
        'twelve': 12,
        'thirteen': 13,
        'fourteen': 14,
        'fifteen': 15,
        'sixteen': 16,
        'seventeen': 17,
        'eighteen': 18,
        'nineteen': 19,
        'twenty': 20,
        'thirty': 30,
        'forty': 40,
        'fifty': 50,
        'sixty': 60,
        'seventy': 70,
        'eighty': 80,
        'ninety': 90
    };

    //Location docs effect for extracting the names of our locations for our dropdown menus
    useEffect(() => {
        const locationNames = []
        locationDocs.forEach( doc => {
            if (!doc.id.startsWith("homebase") && !(doc.data().map === undefined || doc.data().raw === undefined)) {
                locationNames.push(doc.id)
            }
        })
        locationNames.push("homebase")

        //Sort location names based on numbers regardless of whether written out or not
        //Will only work for numbers 0 -> 99, with anything above 20 needing to be two words
        const locationMap = [];
        locationNames.forEach(loc => {
            const numericLoc = [];
            let tokenized = loc.split(" ");
            tokenized.forEach(token => {
                var x = Small[token];
                if (x != null) {
                    numericLoc.push(x);
                } else {
                    numericLoc.push(token);
                }
            })
            locationMap.push({"base": loc, "numeric": numericLoc.join(" ")});
        });
        locationMap.sort(function(a,b) {
            return a.numeric > b.numeric;
        })
       const sortedLocations = []
       locationMap.forEach(l => {
        sortedLocations.push(l.base);
       })
       setLocationNames(sortedLocations)

//        setLocationNames(locationNames)
    }, [locationDocs])

    const handleKioskLocationChange = (event) => {
        setKioskLocation(event.target.value);
    };

    const handleKioskLocationSubmit = () => {
        if (/\S/.test(kioskLocation)) {
            sendUserInput("setkiosklocationto " + kioskLocation);
        } else {
            alert("Please select a location before sending!");
        }
    };

    const generateKioskLocationSetting = () => {
            return (
                <>
                    <Grid container item xs>
                        <Grid item xs={4}>
                            <HeaderTypography>Kiosk Location</HeaderTypography>
                        </Grid>
                        <Grid item xs>
                            <TextField variant={'standard'} onChange={handleKioskLocationChange} select value={kioskLocation}
                                       id="kioskLocationField" label="Location..." fullWidth>
                                {locationNames.map((option) => (
                                    <MenuItem key={option} value={option}>
                                        {option}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                    </Grid>
                    <Grid item xs={1}>
                        <IconButton color="primary" onClick={handleKioskLocationSubmit}>
                             <SendIcon color='send'/>
                        </IconButton>
                    </Grid>
                </>
            )
    };

    const generateKioskActionSetting = () => {
            return (
                <>
                    <Grid container item xs>
                        <Grid item xs={4}>
                            <HeaderTypography>Kiosk Action: </HeaderTypography>
                        </Grid>
                        <Grid item xs>
                            <TextField variant={'standard'} 
                                       autoComplete='off'
                                       disabled="true"
                                       label="Check In (locked)"
                                       helperText="Action associated with kiosk mode"
                                       fullWidth/>
                        </Grid>
                    </Grid>
                    <Grid item xs={1}>
                        <IconButton color="primary">
                             <SendIcon color='send'/>
                        </IconButton>
                    </Grid>
                </>
            )
    };

    const handleKioskTimeoutSubmit = (event) => {
        const setting = document.getElementById('kioskTimeoutField').value;
        if (setting >= 10) {
            sendUserInput("setkiosktimeoutto " + setting);
        } else {
            alert("Please input a valid kiosk timeout number! (Greater than or equal to 10)");
        }
    };

    const generateKioskTimeoutSetting = () => {
            return (
                <>
                    <Grid container item xs>
                        <Grid item xs={4}>
                            <HeaderTypography>Kiosk Timeout: </HeaderTypography>
                        </Grid>
                        <Grid item xs>
                            <TextField variant={'standard'} 
                                       autoComplete='off'
                                       helperText="Number of seconds of inactivity before Zeeno automatically performs the kiosk action"
                                       id="kioskTimeoutField"
                                       label="Kiosk Timeout... (seconds - min. 10)"
                                       type="number"
                                       fullWidth/>
                        </Grid>
                    </Grid>
                    <Grid item xs={1}>
                        <IconButton color="primary" onClick={handleKioskTimeoutSubmit}>
                             <SendIcon color='send'/>
                        </IconButton>
                    </Grid>
                </>
            )
    };

    const handleKioskModeSubmit = (event) => {
        const setting = document.getElementById('kioskModeField').innerText;
        if (setting === "on") {
            sendUserInput("enablekioskmode");
        } else if (setting === "off") {
            sendUserInput("disablekioskmode");
        } else {
            alert("Please select \"on\" or \"off\" before sending");
        }
    };

    const generateKioskEnabledSetting = () => {
            return (
                <>
                    <Grid container item xs>
                        <Grid item xs={4}>
                            <HeaderTypography>Kiosk Mode: </HeaderTypography>
                        </Grid>
                        <Grid item xs>
                            <TextField autoFocus variant={'standard'} select id="kioskModeField" label="Toggle..." helperText="If on, Zeeno will perform the kiosk action automatically after periods of inactivity." fullWidth defaultValue="">
                                <MenuItem key={true} value={true}>
                                    {"on"}
                                </MenuItem>
                                <MenuItem key={false} value={false}>
                                    {"off"}
                                </MenuItem>
                            </TextField>
                        </Grid>
                    </Grid>
                    <Grid item xs={1}>
                        <IconButton color="primary" onClick={handleKioskModeSubmit}>
                             <SendIcon color='send'/>
                        </IconButton>
                    </Grid>
                </>
            )
    };

//    const handleSpeechOverlaySubmit = (event) => {
//        const setting = document.getElementById('speechOverlayField').innerText;
//        if (setting === "on") {
//            sendUserInput("enablettsoverlay");
//        } else if (setting === "off") {
//            sendUserInput("disablettsoverlay");
//        } else {
//            alert("Please select \"on\" or \"off\" before sending");
//        }
//    };

//    const generateGatherLogNames = () => {
//        return (
//            <>
//                <Grid container item xs>
//                    <Grid item xs>
//                        <Paper >Gather log filenames from storage bucket</Paper>
//                    </Grid>
//                </Grid>
//                <Grid item xs={1}>
//                    <IconButton color="primary" onClick={handleGatherLogNamesSubmit}>
//                         <SendIcon color='send'/>
//                    </IconButton>
//                </Grid>
//            </>
//        )
//    };

//    const handleGatherLogNamesSubmit = (event) => {
////        const stor = storage.getStorage();
//        const storageRef = storage.ref();
//        const listRef = storageRef.child("logs/"+group);
//
//        let filenames = []
//        listRef.listAll(listRef)
//          .then((res) => {
////            res.prefixes.forEach((folderRef) => {
////              // All the prefixes under listRef.
////              // You may call listAll() recursively on them.
////            });
//            res.items.forEach((itemRef) => {
//              // All the items under listRef.
//              filenames.push(itemRef.name)
////              console.log(itemRef.name)
//            });
//          }).catch((error) => {
//            console.log(error)
//            // Uh-oh, an error occurred!
//          });
//          console.log(filenames)
//    }

//    const generateSpeechOverlaySetting = () => {
//        return (
//            <>
//                <Grid container item xs>
//                    <Grid item xs>
//                        <Paper >Speech Overlay: </Paper>
//                    </Grid>
//                    <Grid item xs>
//                        <TextField autoFocus variant={'standard'} select id="speechOverlayField" label="Toggle..." helperText="If on, Zeeno will display a text representation of whatever it is saying." fullWidth defaultValue="">
//                            <MenuItem key={true} value={true}>
//                                {"on"}
//                            </MenuItem>
//                            <MenuItem key={false} value={false}>
//                                {"off"}
//                            </MenuItem>
//                        </TextField>
//                    </Grid>
//                </Grid>
//                <Grid item xs={1}>
//                    <IconButton color="primary" onClick={handleSpeechOverlaySubmit}>
//                         <SendIcon color='send'/>
//                    </IconButton>
//                </Grid>
//            </>
//        )
//    };

    const handleBotSwitchChange = (event) => {
        //is index stored in event somewhere?
        let pos = botNames.indexOf(event.target.value);
        setSelectedBot(event.target.value);
        setSelectedSerial(botSerials[pos])
    };

    //Once everything is defined, we're ready to render
    useEffect(() => {
        if (dolphinEnabled !== undefined) {
            setReady(true)
        } else {
            setReady(false)
        }
    }, [dolphinEnabled])


    if (isV2) {
        return (
            <Box>
                <Paper>
                    <Accordion>
                        <AccordionSummary>
                            <Grid container direction="row"
                                  justifyContent="space-between"
                                  alignItems="center">
                                <Grid item>
                                    <Typography variant="h1">Settings</Typography>
                                </Grid>
                                <Grid item>
                                    <IconButton size="small" onClick={() => handleSettingsOpen(settingsOpen)}>
                                        {settingsOpen ? <KeyboardArrowUpIcon fontSize="large"/> : <KeyboardArrowDownIcon fontSize="large"/>}
                                    </IconButton>
                                </Grid>
                            </Grid>
                        </AccordionSummary>
                        <TextField onChange={handleBotSwitchChange} select value={selectedBot}
                                   id="groupSwitchField" label="Robot...">
                            {botNames.map((option) => (
                                <MenuItem key={option} value={option}>
                                    {option}
                                </MenuItem>
                            ))}
                        </TextField>
                        <AccordionDetails>
                            <Grid container
                                  alignItems="center"
                                  justifyContent="center"
                                  spacing={3}>
                                <VolumeComponent/>
                                <Divider/>
                                {generatePrivacyModeSetting()}
                                <Divider/>
                                {generateObstacleNotificationSetting()}
                                <Divider/>
                                {generateSendLogsSetting()}
                                <Divider/>
                                {generateShowTopBarSetting()}
                                <Divider/>
                                {generateSendMapSetting()}
                                <Divider/>
                                {generateRequestPermissionsSetting()}
                                <Divider/>
                                {generateHardwareButtonsSetting()}
                                <Divider/>
                                {generateEscortAttemptsSetting()}
                                <Divider/>
                                {generateEscortDurationSetting()}
                                <Divider/>
                                {generateLowBatteryWarningSetting()}
                                <Divider/>
                                {generateRechargeSetting()}
                                <Divider/>
                                {generateEndChargeSetting()}
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                </Paper>
            </Box>
        )
    }
    else {
        if (ready) {
            return (
                <Paper>
                    {/*Root Accordion*/}
                    <Accordion>
                        <AccordionSummary onClick={() => handleSettingsOpen(settingsOpen)}>
                            <Grid container direction="row"
                                  justifyContent="space-between"
                                  alignItems="center">
                                <Grid item>
                                    <Typography variant="h1" color={'accordionHeader'}>Settings</Typography>
                                </Grid>
                                <Grid item>
                                    <IconButton size="small" onClick={() => handleSettingsOpen(settingsOpen)}>
                                        {settingsOpen ? <KeyboardArrowUpIcon fontSize="large"/> : <KeyboardArrowDownIcon fontSize="large"/>}
                                    </IconButton>
                                </Grid>
                            </Grid>
                        </AccordionSummary>
                        <AccordionDetails>

                            {/*Audio*/}
                            <Accordion>
                                <SubMenuAccordionSummary color={"subHeader"} onClick={() => handleAudioSettingsOpen(audioSettingsOpen)}>
                                    <Grid container direction="row"
                                          justifyContent="space-between"
                                          alignItems="center">
                                        <Grid item>
                                            <Typography variant="h4">Audio</Typography>
                                        </Grid>
                                        <Grid item>
                                            <IconButton size="small" onClick={() => handleAudioSettingsOpen(audioSettingsOpen)}>
                                                {audioSettingsOpen ? <KeyboardArrowUpIcon fontSize="large" color={'alt'}/> : <KeyboardArrowDownIcon fontSize="large" color={'alt'}/>}
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                </SubMenuAccordionSummary>
                                <AccordionDetails>
                                    <Grid container>
                                        {/*Should this even be on the webapp?*/}
                                        {/*<VolumeComponent/>*/}
                                        <Grid item container xs={12} className={classes.subMenuItem}>
                                            {generatePrivacyModeSetting()}
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Divider/>
                                        </Grid>
                                        <Grid item container xs={12} className={classes.subMenuItem}>
                                            {generateVoiceAckSetting()}
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Divider/>
                                        </Grid>
                                        <Grid item container xs={12} className={classes.subMenuItem}>
                                            {generateObstacleNotificationSetting()}
                                        </Grid>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>

                            {/*Kiosk*/}
                            {dolphinEnabled ?
                                <Accordion>
                                    <SubMenuAccordionSummary color={"subHeader"} onClick={() => handleKioskSettingsOpen(kioskSettingsOpen)}>
                                        <Grid container direction="row"
                                              justifyContent="space-between"
                                              alignItems="center">
                                            <Grid item>
                                                <Typography variant="h4">Kiosk</Typography>
                                            </Grid>
                                            <Grid item>
                                                <IconButton size="small" onClick={() => handleKioskSettingsOpen(kioskSettingsOpen)}>
                                                    {kioskSettingsOpen ? <KeyboardArrowUpIcon fontSize="large" color={'alt'}/> : <KeyboardArrowDownIcon fontSize="large" color={'alt'}/>}
                                                </IconButton>
                                            </Grid>
                                        </Grid>
                                    </SubMenuAccordionSummary>
                                    <AccordionDetails>
                                        <Grid item container xs={12} className={classes.subMenuItem}>
                                            {generateKioskEnabledSetting()}
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Divider/>
                                        </Grid>
                                        <Grid item container xs={12} className={classes.subMenuItem}>
                                            {generateKioskTimeoutSetting()}
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Divider/>
                                        </Grid>
                                        <Grid item container xs={12} className={classes.subMenuItem}>
                                            {generateKioskActionSetting()}
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Divider/>
                                        </Grid>
                                        <Grid item container xs={12} className={classes.subMenuItem}>
                                            {generateKioskLocationSetting()}
                                        </Grid>
                                    </AccordionDetails>
                                </Accordion>
                                :
                                <></>
                            }

                            {/*Behaviors*/}
                            <Accordion>
                                <SubMenuAccordionSummary color={"subHeader"} onClick={() => handleBehaviorSettingsOpen(behaviorSettingsOpen)}>
                                    <Grid container direction="row"
                                          justifyContent="space-between"
                                          alignItems="center">
                                        <Grid item>
                                            <Typography variant="h4">Escort</Typography>
                                        </Grid>
                                        <Grid item>
                                            <IconButton size="small" onClick={() => handleBehaviorSettingsOpen(behaviorSettingsOpen)}>
                                                {behaviorSettingsOpen ? <KeyboardArrowUpIcon fontSize="large" color={'alt'}/> : <KeyboardArrowDownIcon fontSize="large" color={'alt'}/>}
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                </SubMenuAccordionSummary>
                                <AccordionDetails>
                                    <Grid item container xs={12} className={classes.subMenuItem}>
                                        {generateEscortAttemptsSetting()}
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Divider/>
                                    </Grid>
                                    <Grid item container xs={12} className={classes.subMenuItem}>
                                        {generateEscortDurationSetting()}
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>

                            {/*Battery*/}
                            <Accordion>
                                <SubMenuAccordionSummary color={"subHeader"} onClick={() => handleBatterySettingsOpen(batterySettingsOpen)}>
                                    <Grid container direction="row"
                                          justifyContent="space-between"
                                          alignItems="center">
                                        <Grid item>
                                            <Typography variant="h4">Battery</Typography>
                                        </Grid>
                                        <Grid item>
                                            <IconButton size="small" onClick={() => handleBatterySettingsOpen(batterySettingsOpen)}>
                                                {batterySettingsOpen ? <KeyboardArrowUpIcon fontSize="large" color={'alt'}/> : <KeyboardArrowDownIcon fontSize="large" color={'alt'}/>}
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                </SubMenuAccordionSummary>
                                <AccordionDetails>
                                    <Grid item container xs={12} className={classes.subMenuItem}>
                                        {generateLowBatteryWarningSetting()}
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Divider/>
                                    </Grid>
                                    <Grid item container xs={12} className={classes.subMenuItem}>
                                        {generateRechargeSetting()}
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Divider/>
                                    </Grid>
                                    <Grid item container xs={12} className={classes.subMenuItem}>
                                        {generateEndChargeSetting()}
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>

                            {/*Utilities*/}
                            <Accordion>
                                <SubMenuAccordionSummary color={"subHeader"} onClick={() => handleUtilitiesSettingsOpen(utilitiesSettingsOpen)}>
                                    <Grid container direction="row"
                                          justifyContent="space-between"
                                          alignItems="center">
                                        <Grid item>
                                            <Typography variant="h4">Utilities</Typography>
                                        </Grid>
                                        <Grid item>
                                            <IconButton size="small" onClick={() => handleUtilitiesSettingsOpen(utilitiesSettingsOpen)}>
                                                {utilitiesSettingsOpen ? <KeyboardArrowUpIcon fontSize="large" color={'alt'}/> : <KeyboardArrowDownIcon fontSize="large" color={'alt'}/>}
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                </SubMenuAccordionSummary>
                                <AccordionDetails>
                                    <Grid item container xs={12} className={classes.subMenuItem}>
                                        {generateSendLogsSetting()}
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Divider/>
                                    </Grid>
                                    {/*<Grid item container xs={12} className={classes.subMenuItem}>*/}
                                    {/*    {generateShowTopBarSetting()}*/}
                                    {/*</Grid>*/}
                                    <Grid item container xs={12} className={classes.subMenuItem}>
                                        {generateSendMapSetting()}
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Divider/>
                                    </Grid>
                                    {/*<Grid item container xs={12} className={classes.subMenuItem}>*/}
                                    {/*    {generateRequestPermissionsSetting()}*/}
                                    {/*</Grid>*/}
                                    <Grid item container xs={12} className={classes.subMenuItem}>
                                        {generateHardwareButtonsSetting()}
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>

                        </AccordionDetails>
                    </Accordion>
                </Paper>
            )
        } else {
            return null;
        }
    }
}

export default SettingsComponent;

//                            {generateGatherLogNames()}
